import { loadable } from 'utils';

export const LineInvoice = loadable(() => import('./LineInvoice'), {});
